import { isObject, isString, startsWith, extend, omit } from 'lodash-es';
import debug from 'debug';
import type { Application } from '../application';
import { Resource } from '../resource';
import { AxiosResponse } from 'axios';

const log = debug('itp:core:actions:crud');

function onResponse(response: AxiosResponse<any, any>) {
  log('response status=%s; data=%o', response.status, response.data);
  if (isObject(response.data)) {
    return new Resource(response.data);
  }
  return response.data;
}

export class CRUD {
  readonly objectType: string;
  readonly app: Application;

  constructor(objectType: string, app: Application) {
    this.objectType = objectType;
    this.app = app;
  }

  public static createCRUD(objectType: string, app: Application) {
    return new CRUD(objectType, app);
  }

  public upsert(data: Dictionary<any>, options?: Dictionary<any>) {
    const id = data.id;

    if (id == null || (isString(id) && startsWith(id, '$$newrow$$'))) {
      return this.create(omit(data, 'id'), options);
    }
    return this.update(data, options);
  }

  public create(data: Dictionary<any>, options?: Dictionary<any>) {
    return this.app.connections
      .request(`create_${this.objectType}`, extend({ content: data }, options))
      .then(onResponse);
  }

  public update(data: Dictionary<any>, options?: Dictionary<any>) {
    let resx: Resource | null = null;
    if (data instanceof Resource) {
      resx = data;
      data = { ...data.getChanges(), id: data.id, etag: data.etag };
    }

    return this.app.connections
      .request(`update_${this.objectType}`, extend({ content: data }, options))
      .then(onResponse);
  }

  public delete(data: Dictionary<any>, options?: Dictionary<any>) {
    return this.app.connections
      .request(`delete_${this.objectType}`, extend({ content: data }, options))
      .then(onResponse);
  }
}
